/* RKP MOTION SYSTEM — one rAF-throttled scroll listener, one IntersectionObserver,
   event delegation for doors/tilt. No libraries. Paired styles in rkp-motion.css. */
(function () {
  'use strict';
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var se = [].slice.call(document.querySelectorAll('[data-motion-scroll]'));
  var ticking = false;
  function upd() {
    ticking = false;
    if (rm || !se.length) return;
    var vh = innerHeight;
    for (var i = 0; i < se.length; i++) {
      var el = se[i], r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      el.style.setProperty('--p', Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height))).toFixed(4));
    }
  }
  if (se.length) {
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    addEventListener('resize', upd, { passive: true });
    upd();
  }

  [].forEach.call(document.querySelectorAll('[data-sprocket-teeth]'), function (g) {
    var n = +g.getAttribute('data-sprocket-teeth') || 24, r1 = +g.getAttribute('data-r1') || 72, r2 = +g.getAttribute('data-r2') || 84, s = '';
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2;
      s += '<path d="M' + (100 + Math.cos(a) * r1).toFixed(1) + ' ' + (100 + Math.sin(a) * r1).toFixed(1) +
        ' L' + (100 + Math.cos(a) * r2).toFixed(1) + ' ' + (100 + Math.sin(a) * r2).toFixed(1) + '"/>';
    }
    g.innerHTML = s;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rkp-door__front');
    if (!btn) return;
    var door = btn.closest('.rkp-door');
    if (!door) return;
    btn.setAttribute('aria-expanded', door.classList.toggle('is-open') ? 'true' : 'false');
  });

  if (!rm && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    [].forEach.call(document.querySelectorAll('.rkp-tilt'), function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height, s = card.style;
        s.setProperty('--tx', (x - 0.5).toFixed(3));
        s.setProperty('--ty', (y - 0.5).toFixed(3));
        s.setProperty('--mx', (x * 100).toFixed(1) + '%');
        s.setProperty('--my', (y * 100).toFixed(1) + '%');
        s.setProperty('--sheen', '1');
      });
      card.addEventListener('pointerleave', function () {
        var s = card.style;
        s.setProperty('--tx', 0); s.setProperty('--ty', 0); s.setProperty('--sheen', '0');
      });
    });
  }

  function cnt(el) {
    var target = +el.getAttribute('data-count') || 0;
    if (rm) { el.textContent = target; return; }
    var t0 = null, dur = 1100;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function fire(el) {
    if (el.classList.contains('rkp-reveal')) el.classList.add('is-in');
    if (el.classList.contains('rkp-counter')) cnt(el);
  }

  var io = null;
  if (!rm && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        fire(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
  }

  function register(el) {
    if (rm || !io || el.getBoundingClientRect().top < innerHeight) fire(el);
    else io.observe(el);
  }

  var rv = [].slice.call(document.querySelectorAll('.rkp-reveal, .rkp-counter[data-count]'));
  rv.forEach(register);

  if (rv.length && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches('.rkp-reveal') || node.matches('.rkp-counter[data-count]'))) register(node);
          if (node.querySelectorAll) [].forEach.call(node.querySelectorAll('.rkp-reveal, .rkp-counter[data-count]'), register);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
